import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getFieldBasicDetails, getFieldBasicDetailsAdmin } from "services";

import { getEnvironment } from "utils";

import { GET_FIELDS_BASIC_DETAILS } from "consts";

export const useGetBasicDetailsForManyFields = (
  fieldIds: string[],
  { enabled, includeDisabledFields }: { enabled?: boolean; includeDisabledFields?: boolean }
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFieldBasicDetailsAdmin : getFieldBasicDetails;

  return useQueries({
    queries: fieldIds.map((fid) => ({
      queryKey: [GET_FIELDS_BASIC_DETAILS, fid, includeDisabledFields],
      queryFn: () => queryFn(fid, includeDisabledFields),
      enabled: (enabled ?? true) && fid.length > 0,
      queryClient,
      gcTime: 0,
    })),
  });
};
